// init
export const init = () => ({
    type: 'INIT'
});
// setActionsDisabled
export const setActionsDisabled = (actionsDisabled) => ({
    type: 'ACTIONS_DISABLED',
    actionsDisabled: actionsDisabled
});
// setLoading
export const setLoading = (loading) => ({
    type: 'LOADING',
    loading: loading,
});
// setLastVisited
export const setLastVisited = (lastVisited) => ({
    type: 'LAST_VISITED',
    lastVisited: lastVisited,
});
// setMenuPerfilAbierto
export const setMenuPerfilAbierto = (menuPerfilAbierto) => ({
    type: 'MENU_PERFIL_ABIERTO',
    menuPerfilAbierto: menuPerfilAbierto,
});
// setItemsCarrito
export const setItemsCarrito = (itemsCarrito) => ({
    type: 'ITEMS_CARRITO',
    itemsCarrito: itemsCarrito,
});
// setIndexTema
export const setIndexTema = (indexTema) => ({
    type: 'INDEX_TEMA',
    indexTema: indexTema,
});
// setPaginaActual
export const setPaginaActual = (paginaActual) => ({
    type: 'PAGINA_ACTUAL',
    paginaActual: paginaActual,
});
// setMensajePredefinido
export const setMensajePredefinido = (mensajePredefinido) => ({
    type: 'MENSAJE_PREDEFINIDO',
    mensajePredefinido: mensajePredefinido,
});
// setScrollBody
export const setScrollBody = (scrollBody) => ({
    type: 'SCROLL_BODY',
    scrollBody: scrollBody,
});